<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.bannerList.push"
    :is-show-search-input="true"
    search-placeholder="输入轮播图名称进行搜索"
  >
    <v-column-time/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="标题" prop="title"/>
    <el-table-column label="链接" prop="link"/>
    <el-table-column label="轮播图">
      <template v-slot="{ row }">
        <v-img :value="row.cover" class="cover"/>
      </template>
    </el-table-column>
    <el-table-column width="210" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.bannerEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row.id)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此轮播图吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`banner-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>标题</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>链接</span>
              <span>{{ v.link }}</span>
            </div>
            <div class="list-item-detail">
              <span>轮播图</span>
              <v-img :value="v.cover" class="cover"/>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.bannerEdit.to(v.id)"/>
              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v.id)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此轮播图吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/banner';

export default {
  name: RouteConfig.bannerList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete(id) {
      if (!id) return this.$message.warning('缺少轮播图 ID，无法删除该轮播图！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>

<style src="./index.css" scoped/>
